export default
`Beste {naam}

In de bijlage vind je je nieuwe dienstenoverzicht.

Met vriendelijke groet,
{bedrijfsnaam}`
